import React from "react";
import DatePicker from './DatePicker'
import FixButton from './Button'
import Cookies from 'universal-cookie';
import moment from 'moment';
import translateString from "../utils/Locales";

let t = translateString;

export default class SelectPdfDatesWidget extends React.Component {

    constructor (props){
        super(props);

        this.daDateRef = React.createRef();
        this.aDateRef = React.createRef();

        this.state = { };

    }

    async componentDidMount(){

        if (this.props.daDate && this.props.toDate) {
            
            const date1 = moment(this.props.daDate, 'yyyy-MM-DD');
            const date2 = moment(this.props.toDate, 'yyyy-MM-DD');

            this.setState({ daDate: date1, toDate: date2 });
        } else {
            this.setState({ daDate: undefined, toDate: undefined });
        }
    
        this.setState({
            visible: this.props.show,
        });

    }

    render (){

        if (!this.state) return <div />;
        let st = Object.assign({display: this.state.visible ? 'block' : 'none'});

        return ( 
            <div style={{...st}}>
                <div style={backView} key={Math.random()} onClick={() => { this.setState({ visible: false }); this.props.onCancel(); }}>
                    <div key={Math.random()} style={mainClass} onClick={(e) => e.stopPropagation()} >
                        <div style={closeIcon} onClick={() => {
                            this.setState({visible: false});
                            this.props.onCancel();
                        }}>
                            <img alt="" src={ require('../images/close_icon.png')} style={{ width: 30, height: 30, cursor: 'pointer' }} />
                        </div>
                        <div style={{marginTop: '10px'}}>
                            <div style={windowTitle} >{t('seleziona_date')}</div>
                            <div style={{ display: 'flex', marginLeft: 5, marginBottom: -10 }}>
                                <img alt="" src={ require('../images/question_icon.png') } style={{ width: 10, height: 10, marginRight: 5, marginTop: 1 }} />
                                <p style={{ fontSize: 10, color: 'darkgray', maxWidth: '80%' }}>{t('date_info')}</p><br/>
                            </div>
                            <DatePicker ref={this.daDateRef} value={this.state.daDate} name={t('da')} />
                            <DatePicker ref={this.aDateRef} value={this.state.toDate} name={t('a')}/>
                            <br/>
                            <FixButton title={t('ok').toUpperCase()} callback={this.okClicked.bind(this)} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    checkInvestor(investors, id){
        investors.map(v => {
            if (v.id == id) return true;
        });
        return false;
    }

    async okClicked(){

        const cookies = new Cookies();

        const daDate = this.daDateRef.current.getDate();
        const aDate = this.aDateRef.current.getDate();

        let da = moment(daDate).format('yyyy-MM-DD');
        let a = moment(aDate).format('yyyy-MM-DD');

        if (da == "Invalid date") da = "";
        if (a == "Invalid date") a = "";

        this.props.onOkClicked(da, a);
    }
}

const windowTitle = {
    color: 'darkgrey', 
    fontSize: 30, 
    fontWeight: 'bold', 
    fontFamily: 'Teko', 
    textAlign:'left', 
    marginLeft: 5, 
}

const closeIcon = {
    position: 'absolute', 
    cursor: 'pointer',
    right: 10, 
    top: 10, 
    padding: 10, 
    zIndex: 999,
}

const backView = {
    position: 'fixed', 
    display: 'block', 
    top: 0,
    left: 0, 
    bottom: 0, 
    right: 0,
    minWidth: '100%', 
    minHeight: '100%', 
    backgroundColor: '#3C3C3C4D',
    overflowX: 'hidden', 
    overflowY: 'scroll',
};

const mainClass = {
    position: 'absolute',
    left: 'calc((100% - 400px)/2',
    top: '25%',
    right: '35%',
    minWidth: '400px',
    width: '400px',
    background: 'white',
    padding: '20px',
    zIndex: 999,
    boxShadow: '0px 2px 10px darkgrey', 
    borderRadius: '10px',
    overflow: 'visible',
}